module.exports = __webpack_public_path__ + "img/6_101.93df5f0a.png";